'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Get whether a component has mounted.
 * @returns boolean
 */ const useMounted = ()=>{
    const isMounted = React.useRef(false);
    React.useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return React.useCallback(()=>isMounted.current, [])();
};

exports.useMounted = useMounted;
//# sourceMappingURL=use-mounted.js.map
